// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2isyS","newExpiryDate":"styles_newExpiryDate__dy5Yh","footer":"styles_footer__3gp-5"};